<template>
  <div class="home">
    <HeroSection :data="heroData" />
    <!-- <EditorialIntro :data="editorialData" /> -->
    <BusinessMatrix :data="matrixData" @navigate="handleNavigate" />
    <BusinessMatrix :data="matrix2Data" @navigate="handleNavigate" />
    <BusinessMatrix :data="matrix3Data" @navigate="handleNavigate" />
    <BusinessMatrix :data="matrix4Data" @navigate="handleNavigate" />
    <Capabilities :data="capabilitiesData" />
    <FeaturedGifts :data="giftsData" />
    <!-- <DataCredibility :data="dataCredibilityData" /> -->
  </div>
</template>

<script>
import HeroSection from "./components/HeroSection.vue";
// import EditorialIntro from "./components/EditorialIntro.vue";
import BusinessMatrix from "./components/BusinessMatrix.vue";
import Capabilities from "./components/Capabilities.vue";
import FeaturedGifts from "./components/FeaturedGifts.vue";
// import DataCredibility from "./components/DataCredibility.vue";

export default {
  name: "Home",
  components: {
    HeroSection,
    // EditorialIntro,
    BusinessMatrix,
    Capabilities,
    FeaturedGifts,
    // DataCredibility,
  },
  data() {
    return {
      heroData: {
        eyebrow: "GUANGDONG CULTURAL ASSET PORTAL",
        title: "文博聚势",
        subTitle: "粤购赋能",
        desc: "深圳文博会线上交易信息公开平台，邀您共赴文化产业新征程！",
        copy: "汇聚广东展团数百优质参展企业，深度联动六大产业与岭南“双创”、“百千万工程”等线下展区，践行“突出企业、突出交易，提升实效”理念，搭建文化产业线上线下融合交易桥梁，让湾区文化产业创新成果可看、可查、可对接、可交易。",
        primaryText: "数据监控平台",
        primaryLink: `${
          process.env.NODE_ENV === "production"
            ? "https://www.yuewengou.com"
            : "https://ywg-w.s136.ailo.vip"
        }/bigScreen/`,
        secondaryText: "浏览业务矩阵",
        secondaryLink: "#",
      },
      editorialData: {
        label: "OFFICIAL TRUST & PARTNERSHIP",
        title: "第二十二届中国（深圳）国际文化产业博览交易会",
        subTitle: "广东展团",
        description: `文博会专属B2B与B2C融合门户网站，聚焦甲方参展商产品展示、侧重专业采购商、C端消费者深度了解广东六大文化产业，并设置"广货行天下"、"数实融合"等专区，实现线上线下交易数据互通，为第三方服务商提供数据支撑与服务入口。`,
        cards: [
          {
            icon: "icon-rili",
            title: "活动排期表",
            description:
              "同步查看展会重点活动、时间安排与参与方式，提前规划现场参观路线。",
            bgColor: "#F3EEE5",
            badgeBg: "#E7D8C3",
            badgeBorder: "#D5BE98",
            dividerColor: "#D9CEBD",
            buttonText: "查看活动",
            buttonLink: "/section/1",
          },
          {
            icon: "icon-diannaobofang",
            title: "直播排期表",
            description:
              "掌握直播场次、主题内容与开播时间，线上同步参与重点发布与分享。",
            bgColor: "#FBF8F3",
            badgeBg: "#F2E7D3",
            badgeBorder: "#D8C6A2",
            dividerColor: "#DDD4C4",
            buttonText: "查看直播",
            buttonLink: "/section/2",
          },
          {
            icon: "icon-duihua",
            title: "专题洽淡会",
            description:
              "聚焦重点议题与供需对接，预约专题洽谈，提升合作沟通效率。",
            bgColor: "#F3EEE5",
            badgeBg: "#F2E7D3",
            badgeBorder: "#D8C6A2",
            dividerColor: "#DDD4C4",
            buttonText: "预约洽谈",
            buttonLink: "/section/3",
          },
        ],
      },
      matrixData: {
        label: "FOUR BUSINESS PILLARS",
        title: "展商专区",
        description: "全部展商，一页纵览，按类可查。",
        cards: [
          // {
          //   title: "展商专区",
          //   description: "找展商，逛内容，一站尽览广东文化消费新面孔。",
          //   image: require("@/assets/images/homepage_matrix_southern_cultural_mall.png"),
          //   route: "CulturalMall",
          // },
          {
            title: "展商名录",
            description: "全部展商，一页纵览，按类可查。",
            image: require("@/assets/images/homepage_matrix_art_trading_platform.png"),
            route: "ArtTrade",
          },
          {
            title: "特色展商",
            description: "品牌深度档案，发现广货里的故事与创新。",
            image: require("@/assets/images/homepage_matrix_guangdong_gifts.png"),
            route: "Gift",
          },
          // {
          //   title: "数遗光年",
          //   description:
          //     "年轻人的潮玩APP，构建了一个非常宏大且迷人的赛博朋克或未来国潮世界观。",
          //   image: require("@/assets/images/homepage_matrix_digital_heritage.png"),
          //   route: "Heritage",
          // },
        ],
      },
      matrix2Data: {
        label: "FOUR BUSINESS PILLARS",
        title: "交易专区",
        description: "买实物、藏数字、淘艺术，好货一站直达。",
        cards: [
          // {
          //   title: "交易专区",
          //   description: "买实物、藏数字、淘艺术，好货一站直达。",
          //   image: require("@/assets/images/homepage_matrix_southern_cultural_mall.png"),
          //   route: "CulturalMall",
          // },
          {
            title: "广货行天下品牌馆",
            description:
              "汇聚老字号、新智造、文创与内容IP，广东好货，由此出发。",
            image: require("@/assets/images/homepage_matrix_art_trading_platform.png"),
            route: "ArtTrade",
          },
          {
            title: "数实融合平台",
            description:
              "实物好物、数字好物、艺术佳作，一个入口，打通虚实消费。",
            image: require("@/assets/images/homepage_matrix_guangdong_gifts.png"),
            route: "Gift",
          },
          // {
          //   title: "数遗光年",
          //   description:
          //     "年轻人的潮玩APP，构建了一个非常宏大且迷人的赛博朋克或未来国潮世界观。",
          //   image: require("@/assets/images/homepage_matrix_digital_heritage.png"),
          //   route: "Heritage",
          // },
        ],
      },
      matrix3Data: {
        label: "FOUR BUSINESS PILLARS",
        title: "活动专区",
        description:
          "线下活动、线上直播，让文化消费不止于静态展示，更是持续发生的现场直播。",
        cards: [
          // {
          //   title: "活动专区",
          //   description:
          //     "线下活动、线上直播，让文化消费不止于静态展示，更是持续发生的现场直播。",
          //   image: require("@/assets/images/homepage_matrix_southern_cultural_mall.png"),
          //   route: "CulturalMall",
          // },
          {
            title: "活动总览",
            description: "全部活动，按日可查。从发布会到沉浸展，一场不落。",
            image: require("@/assets/images/homepage_matrix_art_trading_platform.png"),
            route: "ArtTrade",
          },
          {
            title: "特色活动",
            description: "精选推荐，即时亮点，值得专程奔赴的好活动。",
            image: require("@/assets/images/homepage_matrix_guangdong_gifts.png"),
            route: "Gift",
          },
          // {
          //   title: "数遗光年",
          //   description:
          //     "年轻人的潮玩APP，构建了一个非常宏大且迷人的赛博朋克或未来国潮世界观。",
          //   image: require("@/assets/images/homepage_matrix_digital_heritage.png"),
          //   route: "Heritage",
          // },
        ],
      },
      matrix4Data: {
        label: "FOUR BUSINESS PILLARS",
        title: "服务专区",
        description: "核心能力与外部生态，一站配齐文化产业所需专业服务。",
        cards: [
          // {
          //   title: "服务专区",
          //   description: "核心能力与外部生态，一站配齐文化产业所需专业服务。",
          //   image: require("@/assets/images/homepage_matrix_southern_cultural_mall.png"),
          //   route: "CulturalMall",
          // },
          {
            title: "版权服务",
            description:
              "数字版权登记、交易、确权，依托南方文交所专业资质，为文化资产保驾护航。",
            image: require("@/assets/images/homepage_matrix_art_trading_platform.png"),
            route: "ArtTrade",
          },
          {
            title: "第三方服务",
            description:
              "企业入驻、跨境合作、技术对接，连接第三方服务生态，让展商不止于展示，更能落地生长。",
            image: require("@/assets/images/homepage_matrix_guangdong_gifts.png"),
            route: "Gift",
          },
          // {
          //   title: "数遗光年",
          //   description:
          //     "年轻人的潮玩APP，构建了一个非常宏大且迷人的赛博朋克或未来国潮世界观。",
          //   image: require("@/assets/images/homepage_matrix_digital_heritage.png"),
          //   route: "Heritage",
          // },
        ],
      },
      capabilitiesData: {
        label: "PLATFORM CAPABILITIES",
        title: "技术服务",
        description: "南方数联X区块链双技术筑牢交易安全防线。",
        cards: [
          {
            title: "技术安全",
            description: "南方数联X区块链双技术筑牢交易安全防线。",
            image: require("@/assets/images/homepage_capability_compliance_trade.png"),
            bgColor: "#FBF8F3",
            borderColor: "#DDD4C4",
          },
          {
            title: "信息公开闭环",
            description: "展商信息全公示|交易动态全留痕|链上数据全可溯。",
            image: require("@/assets/images/gifts_still_life_interior.png"),
            bgColor: "#E8EEF4",
            borderColor: "#D7E0EA",
          },
          {
            title: "长效场景赋能",
            description: "双线联动互通，串联广东展团资源生态。",
            image: require("@/assets/images/homepage_capability_appraisal_storage.png"),
            bgColor: "#FBF8F3",
            borderColor: "#DDD4C4",
          },
        ],
      },
      giftsData: {
        label: "FEATURED CULTURAL CURATION",
        title: "重点业务聚焦：广东礼物",
        mainImage: require("@/assets/images/homepage_featured_gifts_main_visual.png"),
        lead: "让广东文化可带走、可体验、可传播",
        description:
          "广东礼物承担整站最强的文化情绪与内容表达，通过非遗工艺、老字号与岭南特产建立地方文化温度。",
        cards: [
          {
            title: "NO.01 / 非遗工艺\n广彩瓷器",
            description: "广州 · 国家级非遗，色彩斑斓，适合收藏与礼赠。",
          },
          {
            title: "NO.02 / 文房精品\n端砚",
            description:
              "肇庆 · 中国四大名砚之首，兼具文化象征与商务礼赠属性。",
          },
          {
            title: "NO.03 / 老字号\n陈李济陈皮",
            description: "广州 · 中华老字号，是岭南养生文化的代表性礼品。",
          },
        ],
      },
      dataCredibilityData: {
        label: "DATA CREDIBILITY",
        title: "用数据强化平台规模与可信度",
        bgImage: require("@/assets/images/homepage_data_credibility_bg.png"),
        metrics: [
          { value: "50亿+", label: "累计交易额" },
          { value: "100万+", label: "注册用户" },
          { value: "10000+", label: "上架藏品" },
          { value: "99.9%", label: "客户满意度" },
        ],
        trendLabel: "交易趋势 / TREND",
        trendDescription:
          "数据区以官网展示方式呈现平台规模与发展趋势，让可信度在清晰表达中自然建立。",
        chartBars: [
          { height: 88, color: "#C6A96B" },
          { height: 132, color: "#E6D7B5" },
          { height: 146, color: "#C6A96B" },
          { height: 210, color: "#DCE5EF" },
          { height: 194, color: "#E6D7B5" },
          { height: 261, color: "#C6A96B" },
        ],
      },
    };
  },
  methods: {
    handleNavigate(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.home {
  @include theme-variable(bg-page);
}
</style>
